// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TableEmptyStateContainer__root___RCFn8","bordered":"TableEmptyStateContainer__bordered___cPsT0"};